import { useEffect, useState } from "react";
import { captureService, captureMessage, prepareLearningRecords, type CaptureState } from "../../lib/learningRecords";
import { useGame } from "../../state/GameProvider";

export function SyncStatus() {
  const { sync, localSaved, retrySync, actions } = useGame();
  const [captureState, setCaptureState] = useState<CaptureState | null>(null);
  useEffect(() => {
    const service = captureService();
    const off = service.onState(setCaptureState);
    void prepareLearningRecords().catch(() => {});
    return off;
  }, []);
  const detail = captureMessage(captureState);
  const message = sync.phase === "syncing" ? "雲端同步中"
    : sync.phase === "synced" ? "雲端已同步"
    : sync.phase === "anonymous" ? "未登入，僅保留本機進度"
    : sync.phase === "error" ? sync.accountChanged ? "登入狀態已變更，請確認原帳號後重試"
      : sync.storageFailed ? "待送資料未能保存，請保留此頁並匯出存檔"
      : sync.quarantined ? "部分原結果已保留待核對，不會自動重送或重評"
      : sync.pendingMapping ? "原結果已保留，等待學習項目對應確認"
      : sync.exhausted ? "已達同步重試上限，原結果仍保留；請聯絡老師核對，勿重做作答"
      : sync.retryable ? `雲端同步未完成（${sync.pending} 筆），原結果已暫存；七天內可續傳，不會重評` : "雲端狀態未確認，本次作答未補交"
    : "作答後可查看同步狀態";
  return <div className={`sync-status ${sync.phase}`} role="status" aria-live="polite">
    <span>{localSaved ? "本機已保存" : "本機儲存不可用，進度暫存於本頁"}</span>
    <span>{message}</span>
    {sync.expired ? <span>{sync.expired} 筆待送資料已超過續傳期限，原結果保留待核對；未補分。</span> : null}
    {detail && <span>{detail}</span>}
    {captureState?.status === "needs_attention" && <button type="button" onClick={() => { void captureService().retry().catch(() => {}); }}>重試完整記錄</button>}
    {sync.retryable && <button type="button" onClick={retrySync}>重試同步</button>}
    {!localSaved && <button type="button" onClick={actions.exportSave}>匯出存檔</button>}
  </div>;
}
